import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import ProductsUpload from '../../Models/ProductsUpload';
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';
import 'rc-menu/assets/index.css';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

class CategoryMenu extends Component {
  constructor(props) {
    super(props);
    this.sendId = this.sendId.bind(this)
    this.state = {
      dropdownOpen: false,
      btnDropright: false,
      categories: []
    };
    this.getCategory()
  }
  // componentDidMount() {
  //   window.scrollTo(0, 0)
  // }

  getCategory() {
    ProductsUpload.getCategory().then(res => {
      this.setState({ categories: res.data.categories })
    })
  }

  sendId(id) {
    console.log('category id', id)
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
      btnDropright: false
    }));
  }

  toggleItem(id) {
    this.state.btnDropright = !this.state.btnDropright;
    if (this.state.btnDropright == true) {
      this.setState({
        btnDropright: false
      });
    } else {
      var sl = {}
      sl[id] = this.state.btnDropright;
      sl[id] = !sl[id];
      this.setState({ btnDropright: sl });
    }
  }
  toggleAll() {
    this.setState(prevState => ({
      btnDropright: !prevState.btnDropright
    }));
  }
  onMouseEnter() {
    this.setState({ dropdownOpen: true })
  }

  onMouseLeave() {
    this.setState({ dropdownOpen: false });
  }

  subCatList(id) {
    this.props.history.push({ pathname: `/sub-categories/${id}`, state: { id: id } });
    window.location.reload();
  }

  Submenu() {
    return (
      <div className="">
        {this.state.categories.map(data =>
          <Dropdown direction="down" isOpen={this.state.btnDropright[data.id]} toggle={this.toggleItem.bind(this, data.id)}>
            <DropdownToggle color='white' caret className="category-right" style={{ width: '100%', textAlign: 'left', backgroundColor: '#f6f4f2', boxShadow: 'none', border: '0px #f4f2f0' }} onClick={this.toggleItem.bind(this, data.id)} >
              {data.category}
            </DropdownToggle>
            <DropdownMenu className="p-0 pb-3"
              style={{
                backgroundColor: '#f8f9fa', width: '270px'
              }}
              modifiers={{
                setMaxHeight: {
                  enabled: true,
                  order: 890,
                  fn: (data) => {
                    return {
                      ...data,
                      styles: {
                        ...data.styles,
                        overflow: 'auto',
                        maxHeight: 400,
                      },
                    };
                  },
                },
                setMinWidth: {
                  enabled: true,
                  order: 890,
                  fn: (data) => {
                    return {
                      ...data,
                      styles: {
                        ...data.styles,
                        // overflow: 'auto',
                        minWidth: 270,
                        left: -5
                      },
                    };
                  },
                },
              }}
            >
              {data.sub_category.map(data =>
                <DropdownItem className="p-1 pb-3" style={{ backgroundColor: "#f8f9fa" }}>
                  <div className="category-right" onClick={this.subCatList.bind(this, data.id)}>
                    {data.cat_name}
                  </div>
                </DropdownItem>
              )}
            </DropdownMenu>
          </Dropdown>
        )}
      </div>
    )
  }

  render() {
    const isMobile = window.innerWidth <= 500;
    const isDesktop = window.innerWidth >= 500;
    //For Mobile view 
    if (isMobile) {
      return (
        <span></span>
      );
    }
    //for desktop view
    else if (isDesktop) {
      return (
        <span></span>
      );
    }
  }
}
CategoryMenu = withRouter(CategoryMenu);
export { CategoryMenu };